
import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Components
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { SearchField } from "../../../Components/formElements/SearchField";
import { MessageCircle } from "lucide-react";
import ChatBox from "../../../Components/ChatBox/ChatBox";
import ReverseTimer from "../../../Components/TableReverseTimer/ReverseTimer";
import { formatDateTime } from "../../../common/Validations";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addauctionNr,
  getEauction,
} from "../../../redux/feature/supplier_app/eauctionSlice";
import StickyColumn from "../../../Components/Sticky/StickyColumn";
import ItemService from "../../../services/customer_appCommonService";

//  Main Component 
const BuyerReverseAuctionList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "eAuction");
  localStorage.setItem("submenu", "Reverse Auction");

  let customerData = useSelector((state) => state.eauctionSlice.eauction);
  let customerTable = useSelector(
    (state) => state.eauctionSlice.eauction.pagination
  );

  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [chatId, setChatId] = useState(null);

  const itemLevelHideModal = () => setItemLevelModalShow(false);
  const toggleCardVisibility = () => setCardVisible(!isCardVisible);

  useEffect(() => {
    setData(customerData?.data);
  }, [customerData]);

  const handlePageChange = (page) => {
    let obj = {
      queryName: "ReverseAuctionList",
      module: "",
      page: page,
      per_page: getNewPerPage,
    };
    dispatch(getEauction(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "ReverseAuctionList",
      module: "",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getEauction(obj));
  };

  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "ReverseAuctionList",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getEauction(obj));
  };

  useEffect(() => {
    let obj = {
      queryName: "ReverseAuctionList",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getEauction(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //  Live Auction click → direct navigate (no modal) 
  const liveAuction = (auctionRow) => {
    dispatch(addauctionNr(auctionRow?.documentNumber));
    navigate(Constants.EAUCTION_LIVE_AUCTION_DETAILS);
  };

  const detailedCommercialEvaluation = () => {
    navigate(Constants.EAUCTION_BUYERAUCTION_CREATE);
  };

  const auctionDetail = (auctionNr) => {
    dispatch(addauctionNr(auctionNr?.documentNumber));
    navigate(Constants.EAUCTION_BUYERAUCTION_DETAILS);
  };

  const toggleChat = (groupId) => {
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };

  const handleDownloadReport = async (row) => {
    try {
      const auctionId = row?.documentNumber || row?.auctionNr;
      if (!auctionId) return alert("Auction ID not found");
      const blob = await ItemService.downloadAuctionReport({ auctionId });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `eAuction_Report_${auctionId}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("PDF download failed:", err);
      alert("Failed to download report. Please try again.");
    }
  };

  const columns = [
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span className="iconTable">
            <button
              onClick={() => toggleChat(row?.userId)}
              title={row?.userId ? "Chat With the User" : "No User Found"}
            >
              <MessageCircle className="w-5 h-5" />
            </button>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
          <span className="iconTable">
            <button
              title="Download Auction Report PDF"
              onClick={() => handleDownloadReport(row)}
              style={{ color: "#c0392b" }}
            >
              <i
                className="bi bi-file-earmark-pdf-fill"
                style={{ fontSize: "16px" }}
              ></i>
            </button>
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Auction Number",
      cell: (row) => (
        <button className="btnInfo" onClick={() => auctionDetail(row)}>
          {row.auctionNr || "-"}{" "}
        </button>
      ),
      selector: (row) => row.auctionNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "RFQ Number",
      selector: (row) => row.rfqNr || "--",
      sortable: true,
      style: {
        position: "sticky",
        left: 0,
        background: "#fff",
        zIndex: 2,
      },
      cell: (row) => (
        <button className="btnInfo" onClick={() => auctionDetail(row)}>
          {row.rfqNr || "-"}{" "}
        </button>
      ),
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) => row?.auctionStatus,
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.auctionStatus}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Start Time",
      selector: (row) => formatDateTime(row.openingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "End Time",
      selector: (row) => formatDateTime(row.closingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Remaining Time",
      cell: (row) => (
        <>
          <ReverseTimer
            key={row.closingDateTime}
            openingDateTime={row.openingDateTime}
            closingDateTime={row.closingDateTime}
          />
        </>
      ),
      sortable: true,
      width: "270px",
    },
    {
      name: "Live Auction",
      cell: (row) => (
        <button
          className="btn btnTable"
          onClick={() => liveAuction(row)}
          style={{
            background: "#0f766e",
            color: "#fff",
            border: "none",
            fontWeight: 600,
            fontSize: "12px",
          }}
        >
          <i className="bi bi-broadcast me-1"></i>
          Live
        </button>
      ),
      selector: (row) => row.liveAuction || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Auction Title",
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row?.auctionTitle}</span>
      ),
      selector: (row) => row.auctionTitle || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Auction Description",
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row?.auctionDescription}</span>
      ),
      selector: (row) => row.auctionDescription || "--",
      sortable: true,
      width: "200px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Reverse Auction</h2>
                <p className="subText">Lists of Reverse Auction and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) =>
                    setCommonSearchTxt(event.target.value)
                  }
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <hr />
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RL</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Reverse Auction List</span>
                      <span className="subHeaderTitle">
                        View of Reverse Auction and Status
                      </span>
                    </Col>
                    <Col
                      xs={4}
                      md={2}
                      lg={2}
                      className="d-flex justify-content-end"
                    >
                      <button
                        className="btnTable"
                        onClick={detailedCommercialEvaluation}
                      >
                        <i className="bi bi-plus-lg"></i> Create Reverse Auction
                      </button>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[3, 4]}
                        leftOffsets={[0, 140]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          progressPending={customerData?.status}
                          paginationTotalRows={customerTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
      />

      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default BuyerReverseAuctionList;
